:root {
  --input-height: 36px;
  --small-input-height: 28px;
  --input-border-radius: 5px;
  --input-font-size: 14px;
  --input-line-height: 24px;
  --input-border-color: #d3d6dc;
  --input-disabled-bg: #f2f4f6;
}

.input {
  border-color: var(--input-border-color);
  border-width: 1px;
  border-radius: var(--input-border-radius);
  font-size: var(--input-font-size);
  line-height: var(--input-line-height);
  height: var(--input-height);
  background-color: white;
}

.input[data-disabled] {
  background-color: var(--input-disabled-bg);
  color: black;
  opacity: 1;
}

.input[data-error] {
  border-color: var(--mantine-color-error);
}

.smallInput {
  border-color: var(--input-border-color);
  border-width: 1px;
  border-radius: var(--input-border-radius);
  font-size: var(--input-font-size);
  line-height: var(--input-line-height);
  min-width: min-content;
  height: var(--small-input-height);
  min-height: var(--small-input-height);
  background-color: white;
}

.smallInput[data-disabled] {
  background-color: var(--input-disabled-bg);
  color: black;
  opacity: 1;
}

.smallInput[data-error] {
  border-color: var(--mantine-color-error);
}

.smallInputHeight {
  height: var(--small-input-height);
  min-height: var(--small-input-height);
}

.highlight {
  border-color: #4675f5;
  border-width: 2px;
  border-style: solid;
}

.label {
  color: black;
  font-size: var(--input-font-size);
}

.smallLabel {
  color: black;
  font-size: var(--input-font-size);
}

.calendarIcon {
  color: black;
}

.description {
  font-size: var(--input-font-size);
}

.totalInput[data-disabled] {
  background-color: #d3d6dc;
}

.totalLabel {
  font-weight: 600;
}
